<lib-dialog-layout [showActions]="true" [alignActions]="'center'">
  <ng-container content>
    <div class="mb3">
      <lib-simple-dialog-content
        [mainText]="data.message"
        [image]="data.image"
        [themedImage]="data.themedImage"
      ></lib-simple-dialog-content>
    </div>
  </ng-container>

  <ng-container actions>
    <div class="mb3">
      <lib-button weight="primary" class="app-dismiss-button" (click)="onDismiss()">
        {{ data.dismissText }}
      </lib-button>
    </div>
  </ng-container>
</lib-dialog-layout>
